import * as React from "react";
import { forwardRef } from "react";
const SvgMinusIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M14.25 9.75H10.5H9.75H8.25H7.5H3.75V8.25H7.5H8.25H9.75H10.5H14.25V9.75Z", fill: "#89A6FF" }));
const ForwardRef = forwardRef(SvgMinusIcon);
export { ForwardRef as ReactComponent };
